// @ts-nocheck
/* eslint-disable */
export const flCaretDownIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.433 16.25C12.2406 16.5833 11.7594 16.5833 11.567 16.25L8.10289 10.25C7.91044 9.91667 8.151 9.5 8.5359 9.5L15.4641 9.5C15.849 9.5 16.0896 9.91667 15.8971 10.25L12.433 16.25Z" fill="currentColor"/></svg>`,
    name: 'caret-down' as const
};